var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2D4E6D",
    d: "m13.964 13.138-3.895-3.896A4.46 4.46 0 0 0 11 6.5c0-1.203-.47-2.331-1.319-3.182A4.47 4.47 0 0 0 6.5 2c-1.202 0-2.333.47-3.182 1.318A4.46 4.46 0 0 0 2 6.5c0 1.201.47 2.332 1.318 3.181A4.46 4.46 0 0 0 6.5 11a4.46 4.46 0 0 0 2.74-.93l3.896 3.894a.12.12 0 0 0 .087.036.12.12 0 0 0 .087-.036l.654-.652a.123.123 0 0 0 0-.175M8.876 8.875A3.34 3.34 0 0 1 6.5 9.86c-.897 0-1.74-.35-2.376-.984A3.34 3.34 0 0 1 3.14 6.5c0-.897.35-1.742.984-2.376A3.34 3.34 0 0 1 6.5 3.14c.897 0 1.741.348 2.376.984S9.86 5.603 9.86 6.5a3.34 3.34 0 0 1-.984 2.376"
  })));
};
export default SvgSearch;